<div [@slideInOut]="" class="row contenedorInputs">
    <div class="fondo"></div>
    <div *ngIf="!hidePassword && !loadingResponse" class="fondo2"></div>
    <div *ngIf="hidePassword" class="fondo2-fp"></div>
    <div class="row inputs">
        <div class="row inputs-logo">
            <img class="img-logo" src="assets/img/login/VCA-Login.png" alt="Vehicle Check App">
        </div>

        <div class="inputs-texto">
            <p class="ingreso_titulo">Portal Vehicle Check App</p>
        </div>
        <div class="row  inputs-campos" [formGroup]="loginForm">
            <div class="row inputs">
                <mat-form-field [hideRequiredMarker]="true">
                    <input (keydown.enter)="validar()" matInput placeholder="Usuario" formControlName="usuario"
                        class="loginInput" required>
                    <mat-error *ngFor="let validation of validation_messages_login.usuario">
                        <mat-error class="error-message"
                            *ngIf="loginForm.get('usuario').hasError(validation.type) && (loginForm.get('usuario').dirty || loginForm.get('usuario').touched)">
                            {{validation.message}}
                        </mat-error>
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="row inputs" [hidden]="hidePassword || checkEmail">
                <mat-form-field [hideRequiredMarker]="true">
                    <input (keydown.enter)="validar()" matInput placeholder="Contraseña" formControlName="contrasena"
                        autocomplete="new-password" class="loginInput" [type]="hide ? 'password' : 'text'" required>
                    <mat-icon class="eyeIcon" matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' :
                        'visibility'}}</mat-icon>
                    <mat-error *ngFor="let validation of validation_messages_login.contrasena">
                        <mat-error class="error-message"
                            *ngIf="loginForm.get('contrasena').hasError(validation.type) && (loginForm.get('contrasena').dirty || loginForm.get('contrasena').touched)">
                            {{validation.message}}
                        </mat-error>
                    </mat-error>
                </mat-form-field>
                <div *ngIf="mensajeErrorLogin" class="errorMsgs"><span
                        *ngIf="!loadingResponse">{{mensajeErrorLogin}}</span></div>
            </div>
            <div class="forgotPassword">
                <p *ngIf="hidePassword === false" (click)="toggleForgotPassWord()">¿Olvidaste la contraseña?</p>
                <p *ngIf="hidePassword">Al cliquear en Enviar, recibirás un correo con las indicaciones para recuperar
                    la contraseña</p>
            </div>
        </div>
        <div *ngIf="loadingResponse" class="row btningresar">
            <app-spinner></app-spinner>
        </div>
        <div *ngIf="!loadingResponse" class="row btningresar">
            <div class="btnIngresarWrapper">
                <button
                    [ngClass]="hidePassword && !loginForm.value.usuario ? 'btnLoginD' : !hidePassword && !loginForm.valid ? 'btnLoginD' : 'btnLogin' "
                    [disabled]="hidePassword ? !loginForm.value.usuario : !loginForm.valid"
                    (click)="hidePassword ? forgotPassword() : validar()">
                    <span *ngIf="!hidePassword">Ingresar</span><span *ngIf="hidePassword">Enviar</span>
                    <!-- <mat-icon style="color: #007749;">arrow_right_alt</mat-icon> -->
                </button>
                <button [ngClass]="hidePassword ? 'backBtnLoginV' : 'backBtnLogin'" (click)="hidePassword = false">
                    Volver
                    <!-- <mat-icon style="color: #007749;">arrow_right_alt</mat-icon> -->
                </button>
            </div>
        </div>
    </div>
</div>

<footer class="loginFooter">
    <div class="row img-logo-footer">
        <a href="http://www.grupomurchison.com.ar/"><img class="img_logo"
                src="assets/img/login/Grupo-Murchison-BLANCO_200x73.png" alt="GRUPO MURCHISON"></a>
    </div>
   
</footer>

<ng-template #tmpChooseClient style="opacity: 0.9;">
    <mat-card style="background-color: #007749;">
        <h3 style=" color: white;">Seleccionar Clientes</h3>
    </mat-card>
    <mat-card style="height: 30%;">
        <mat-card-content>
             <!-- <p-dropdown required class="limited-selector" id="dropdownCli" placeholder="Cliente"
                [style]="{'width':'100%','margin-bottom':'10px', 'margin-top':'10px'}" [options]="clientes"
                [(ngModel)]="clienteSelected" [virtualScroll]="true" [itemSize]="31" [filter]="true">
            </p-dropdown>  -->

            <nb-select
            [(ngModel)]="clienteSelected"
            placeholder="Cliente"
            fullWidth
            [status]="'primary'"
            style="margin-top: 10px; margin-bottom: 10px;">
            <nb-option *ngFor="let cliente of clientes" [value]="cliente.id">
                {{ cliente.nombre }}
            </nb-option>
            </nb-select>


               <!-- <nb-select size="tiny" placeholder="Buque"
                 [(ngModel)]="buqueSelected" 
                 (ngModelChange)="changeBuque()">
                    <nb-option *ngFor="let buque of buques" 
                    [value]="buque.descripcion">{{buque.descripcion}}
                    </nb-option>
                </nb-select> -->


        </mat-card-content>
        <mat-card-actions>
            <div style="float: left;">
                <button mat-button class="buttontz" (click)="hideConfirm()">Cancelar</button>
            </div>
            <div style="float: right;">
                <button mat-button class="buttontz" (click)="elegirCliente()">Guardar</button>
            </div>
        </mat-card-actions>
    </mat-card>
</ng-template>

<ng-template #termsConditions style="opacity: 0.9;">
    <mat-card style="background-color: #007749; text-align: center;">
        <h3 style="color: white">Términos y Condiciones de Uso</h3>
    </mat-card>
    <mat-card style="height: 30%;">
        <mat-card-content style="color: black;">
            Cada empresa o persona proveedora de servicios (movimiento, transporte, etc. de unidades/vehículos) que sea
            dada de alta en el sistema por parte del Usuario Administrador (Ford Argentina S.A.) será un Usuario de esta
            plataforma. <br>
            Como tal se obliga a volcar o insertar en ella con veracidad, circunstanciadamente y en debida forma y
            tiempo toda la información, datos o transacciones relativos a la recepción /entrega/movimiento, etc. de
            unidades/vehículos, lo cual constituye la finalidad de instrumentación de esta plataforma, asumiendo el
            Usuario la responsabilidad que pudiera caberle por las pérdidas, roturas y todo tipo de daño a las
            unidades/vehículos que deriven de su acción u omisión como parte integrante que es de la cadena logística.
            <br>
            En tal sentido el Usuario también acepta las decisiones del Usuario Administrador en materia de
            determinación de tales daños o pérdidas, su atribución -individual o compartida- al/los Usuario/s del
            sistema, su cuantificación y la forma y modalidades de su reparación o indemnización, incluida la
            posibilidad de que tales importes o valores sean debitados de la facturación que emita el Usuario a la
            Terminal Automotriz. <br>
            Asimismo, el Usuario se hace cargo del debido resguardo de las claves o contraseñas que genere para operar
            en el sistema, manteniéndose bajo aquellas responsabilidades y obligaciones aun en caso de un supuesto
            indebido uso de las mismas por parte terceros, sea a consecuencia de un abuso de confianza por parte de
            éstos, en razón del extravío, hurto o robo del/ los dispositivo/s correspondiente/s o por cualquier otra
            causa, renunciando en forma irrevocable a invocar situaciones de ese tipo con el fin de desligarse de ellas.
            <br>
          <div style="display: flex; justify-content: center;">
            <label class="custom-checkbox" 
                style="cursor: pointer; margin-top: 10px; margin-bottom: 10px; display: flex; align-items: center; gap: 5px;">
                <input style="cursor: pointer;" type="checkbox" [(ngModel)]="checkTermsConditions" />
                He leído y acepto
            </label>
            </div>
        </mat-card-content>
        <mat-card-actions style="display: flex; justify-content: space-between;">
            <button mat-button class="buttontz" (click)="hideConfirmTerms()">Cancelar</button>
            <button mat-button class="buttontz" [disabled]="!checkTermsConditions" (click)="savetermsConditions()">Aceptar</button>
            </mat-card-actions>

        <!-- <mat-card-actions>
            <div style="float: left">
                <button mat-button class="buttontz" (click)="hideConfirmTerms()">Cancelar</button>
            </div>
            <div style="float: right;">
                <button mat-button class="buttontz" [disabled]="!checkTermsConditions"
                    (click)="savetermsConditions()">Aceptar</button>
            </div>
        </mat-card-actions> -->
    </mat-card>
</ng-template>

<div *ngIf="snackBar" class="snackBarContainer">
    <div class="snackBar">
        {{customSnackBarMsg}}
    </div>
</div>